'use client';
import { sortBreakpoints, getNextBreakpoint } from '../../../responsive/breakpoints/breakpoints.js';
import { getSize } from '../../../modules/sizes/impl/getSize/getSize.js';
import { unit, rem, em } from '../../../modules/sizes/impl/units/units.js';

function createBreakpointFns(breakpoints) {
    var sortedBreakpoints = sortBreakpoints(breakpoints);
    var getEvaluatedSize = function(size) {
        return getSize({
            size: size,
            sizes: breakpoints
        });
    };
    var media = function(query, noMediaKeyword) {
        return "" + (!noMediaKeyword ? "@media " : "") + query;
    };
    var convert = function(raw, units) {
        if (units === "rem") {
            return rem(raw);
        } else if (units === "em") {
            return em(raw);
        }
        return "" + raw + "px";
    };
    var up = function(from, units, noMediaKeyword) {
        var value = unit(getEvaluatedSize(from));
        var width = convert(Number.isNaN(value) ? from : value, units);
        return media("(min-width: " + width + ")", noMediaKeyword);
    };
    var down = function(from, units, noMediaKeyword) {
        var value = unit(getEvaluatedSize(from));
        var width = convert(Number.isNaN(value) ? from : value - 1, units);
        return media("(max-width: " + width + ")", noMediaKeyword);
    };
    var between = function(from, to, units, noMediaKeyword) {
        var _from = unit(getEvaluatedSize(from));
        var _to = unit(getEvaluatedSize(to));
        var startValue = Math.min(_from, _to);
        var endValue = Math.max(_from, _to);
        var startWidth = convert(Number.isNaN(startValue) ? from : startValue, units);
        var endWidth = convert(Number.isNaN(endValue) ? to : endValue - 1, units);
        return media("(min-width: " + startWidth + ") and (max-width: " + endWidth + ")", noMediaKeyword);
    };
    var only = function(from, units, noMediaKeyword) {
        if (typeof breakpoints[from] === "undefined") {
            throw new Error("Функция темы only поддерживает только размеры ThemeBreakpointSize");
        }
        var startWidth = convert(unit(breakpoints[from]), units);
        var endWidth = getNextBreakpoint(sortedBreakpoints, from);
        if (endWidth) {
            return media("(min-width: " + startWidth + ") and (max-width: " + convert(endWidth.value - 1, units) + ")", noMediaKeyword);
        }
        return media("(min-width: " + startWidth + ")", noMediaKeyword);
    };
    var not = function(from, units, noMediaKeyword) {
        if (typeof breakpoints[from] === "undefined") {
            throw new Error("Функция темы not поддерживает только размеры ThemeBreakpointSize");
        }
        var startWidth = convert(unit(breakpoints[from]) - 1, units);
        var endWidth = getNextBreakpoint(sortedBreakpoints, from);
        if (endWidth) {
            return media("(max-width: " + startWidth + ") and (min-width: " + convert(endWidth.value, units) + ")", noMediaKeyword);
        }
        return "";
    };
    return {
        up: up,
        down: down,
        between: between,
        only: only,
        not: not
    };
}

export { createBreakpointFns };
